module.exports = __webpack_public_path__ + "img/violet_140.00419fa3.png";